import ReactDOM from "react-dom";
import { createPortal } from "react-dom";
import { PageData, UserContext } from "../Definitions/UserContext";
import { BusienssControlNames, GenericBusinessControl } from "./GenericBusinessControl";
import React, { useEffect } from "react";
import LayoutNode from "../Definitions/LayoutNode";
import GenericDynamicComponent from "./GenericDynamicComponent";
import { ValidateToken } from "../Utilities/BusinessData";
import {hasAcceptedValue, getCookie,setCookie, GetTrackingCookieName } from "../Utilities/CookieUtils";
import { BindAllToggles } from "./BindAllToggles";
import { BindServiceLinks,BindClassLinks, BindMembershipLinks, BindPackageLinks } from "./BindServiceAndClassLinks";
import  GtagAccept  from "./GtagAccept";
import { wBComponentTypeNames } from "../Definitions/WBComponentTypeNames";
import { TrackingOnLoad } from "./TrackingOnLoad";

const dataBindKey = "data-link-key";
const componetAttKey = "component-attributes"

interface PortalConfig {
    element: Element;
    component: React.ReactElement;
    key: string;
}

// Root component that renders all portals
const PortalRoot: React.FC<{ portals: PortalConfig[],onFinish?: Function }> = ({ portals,onFinish }) => {

    useEffect(() => {
        onFinish && onFinish();
    }, []);

    return (
        <>
            {portals.map(({ element, component, key }) =>
                createPortal(component, element as HTMLElement, key)
            )}
        </>
    );
};

export default async function BindDataToComponents(businessId: string, accessToken: string, MultilocationData: any, bidHash: string, tokenExpiresAt?: number, isMysite?: boolean, onFinish?: Function, VGURL?: string, isDuplicateAllLocationPage?: boolean, sitebid?: string, nickname?: string, isShoppingCart?: boolean, websitename?: string, telephone?: string, isDormantPage?: boolean, staticencbid?: string, parentbid?: string, isDisplayHomeInVagaroPlus?: boolean, studioNumber?: string,countryID?: string) {

    let pages:PageData[] = [];

    let navDom = document.querySelector("[componenttype='navigationBar']");

    if (navDom) {
        let atts = navDom.getAttribute(componetAttKey) ?? "";
        try {
            const str = decodeURIComponent(atts);
            const attData = str ? JSON.parse(str) : {};
            pages = JSON.parse(attData.pages ?? "[]") as PageData[];
        } catch (e) {
            console.warn(e);
        }

    }

    const context: UserContext = {
        businessId: businessId,
        accessToken: accessToken,
        styleId: "",
        layoutId: "",
        userId: 0,
        pages: pages,
        userType: 1,
        encUserId: "",
        cdnURL: "",
        tokenExpiresAt: tokenExpiresAt,
        imageMapping: [],
        MultilocationData : MultilocationData,
        isMysite : isMysite??false,
        bidHash :bidHash,
        vgurl:VGURL,
        isDuplicateAllLocationPage:isDuplicateAllLocationPage,
        sitebid:sitebid,
        nickname:nickname,
		isShoppingCart:isShoppingCart,
        websitename:websitename,
        telephone:telephone,
        staticencbid: staticencbid,
        encryptMID: staticencbid,
        parentbid: parentbid,
        isDormant: typeof isDormantPage === 'boolean' && isDormantPage === true ? true : false,
        isDisplayHomeInVagaroPlus: typeof isDisplayHomeInVagaroPlus === 'boolean' && isDisplayHomeInVagaroPlus === true ? true : false,
        studioNumber : studioNumber,
        countryCode: countryID?parseInt(countryID):0
    }

    await ValidateToken(context);

    // Business Track Event on PageLoad
    if ((typeof isDormantPage === 'boolean' && isDormantPage === true) || (typeof isDisplayHomeInVagaroPlus === 'boolean' && isDisplayHomeInVagaroPlus === true)) {
        TrackingOnLoad(context);
    }


    //insert business place holder for backlinks before querying for business elements.
    let poweredByVagaro = document.querySelector(".render [href='https://www.vagaro.com/pro/booking-website-builder']");


    if (poweredByVagaro) {

        let check = document.getElementById("vagaro-backlinks-container");

        let otherLinks = poweredByVagaro.parentElement?.childNodes;
         (otherLinks ?? []).forEach(link=>{
            if(link != poweredByVagaro){
                link.remove();
            }
        });

        if(!check){
            let comp = document.createElement("span");
            comp.id = "vagaro-backlinks-container";
            comp.style.display = "inline-flex";
            comp.setAttribute(dataBindKey,BusienssControlNames.backLinks);
            poweredByVagaro.after(comp);
        }
    }

    // OPTIMIZATION 1: Single DOM scan for all selectors
    const selectors = [
        { selector: `[${dataBindKey}]`, type: 'business' },
        { selector: `[${componetAttKey}]`, type: 'component' },
        { selector: '.v-site.render .v-html-embed script, #head-code script, #footer-code script', type: 'script' },
        { selector: '.scroll-link', type: 'scrollLink' },
        { selector: 'a', type: 'link' }
    ];

    const elementsByType: Record<string, Element[]> = {};

    // Single pass through DOM
    selectors.forEach(({ selector, type }) => {
        elementsByType[type] = Array.from(document.querySelectorAll(selector));
    });

    // OPTIMIZATION 2: Collect all portal configurations
    const portals: PortalConfig[] = [];

    try {
        // Prepare business control portals
            elementsByType['business']?.forEach((element, index) => {
            const layout = element.getAttribute("layout") || "";
            const dataKey = element.getAttribute(dataBindKey);
            const bid = element.getAttribute("encbid");
            const filters = element.getAttribute("filters") ? decodeURIComponent(element.getAttribute("filters")!) : "";
            const allowMulti = element.getAttribute("multilocal") === "true";
            const isShowLogo = element.getAttribute("isshowlogo") === "true" ? "true" : "false";
            const displayform = element.getAttribute("displayform") ?? "true";
            const formbg = element.getAttribute("formbg") ?? "";
            const formfc = element.getAttribute("formfc") ?? "";

            // Hide CTA for certain components
            if (dataKey && (dataKey === BusienssControlNames.booknow || dataKey === BusienssControlNames.classes || dataKey === BusienssControlNames.productDetails)) {
                document.body.classList.add("hide-cta");
            }

            if (dataKey) {
                portals.push({
                    element,
                    key: `business-${element.id || index}`,
                    component: (
                        <GenericBusinessControl
                            dataKey={dataKey}
                            filters={filters}
                            userContext={context}
                            bLocationId={bid}
                            layout={layout}
                            rootId={element.id.substring(0, 6)}
                            allowMultiLoc={allowMulti}
                            isShowLogo={isShowLogo}
                            formbg={formbg}
                            formfc={formfc}
                            displayform={displayform}
                        />
                    )
                });
            }
        });
    } catch (e) {
        console.warn(e);
    }

    // Prepare component portals
    elementsByType['component']?.forEach((element, index) => {
        const atts = element.getAttribute(componetAttKey) ?? "";

        try {
            const str = decodeURIComponent(atts);
            const attData = str ? JSON.parse(str) : {};
            const key = element.getAttribute("componenttype") ?? "";

            if ((attData && str) || (key === wBComponentTypeNames.subscriptionThankYou)) {
                const node = new LayoutNode();
                node.id = element.id;
                node.componentAttributes = attData;
                element.setAttribute(componetAttKey, "");

                portals.push({
                    element,
                    key: `component-${element.id || index}`,
                    component: <GenericDynamicComponent dataKey={key} node={node} context={context} />
                });
            }
        } catch (e) {
            console.warn(e);
        }
    });

    // OPTIMIZATION 3: Single render with all portals
    if (portals.length > 0) {
        // Clear all portal target elements first
        portals.forEach(({ element }) => {
            (element as HTMLElement).innerHTML = '';
        });

        const rootContainer = document.createElement('div');
        rootContainer.id = 'vagaro-portal-root';
        rootContainer.style.display = 'none';
        document.body.appendChild(rootContainer);

        ReactDOM.render(<PortalRoot onFinish={onFinish} portals={portals} />, rootContainer);
    }

    // OPTIMIZATION 4: Process embeds (already extracted from DOM)
    elementsByType['script']?.forEach((scrpt) => {
        const src = scrpt.getAttribute("src");
        const parent = scrpt.parentElement;

        if (parent) {
            const newScript = document.createElement("script");
            newScript.async = true;
            if (src) {
                newScript.src = src + "?cachebuster=" + Date.now();
            }
            newScript.innerHTML = scrpt.innerHTML;
            parent.replaceChild(newScript, scrpt);
        }
    });

    // OPTIMIZATION 5: Run non-render operations in parallel
    await Promise.all([
        Promise.resolve(BindAllToggles()),
        Promise.resolve(BindServiceLinks(context)),
        Promise.resolve(BindClassLinks(context)),
        Promise.resolve(BindMembershipLinks(context)),
        Promise.resolve(BindPackageLinks(context))
    ]);

    // Process scroll links
    elementsByType['scrollLink']?.forEach((link) => {
        if (!link.classList.contains("hierarchy")) return;

        let href = link.getAttribute("href");
        if (href && href.startsWith("#")) {
            let url = window.location.href;
            const hash = url.indexOf("#");
            if (hash > 0) {
                url = url.substring(0, hash);
            }
            href = url + href;
            link.setAttribute("href", href);
        }
    });

    // Announcement banner (synchronous, lightweight)
    const clsAnnouncement = document.getElementById("close-announcement-btn");
    if (clsAnnouncement) {
        const announcement = clsAnnouncement.parentElement;
        const expiresAt = announcement?.getAttribute("data-expires-at");
        let expired = false;

        if (expiresAt) {
            const date = new Date(expiresAt);
            if (date && !isNaN(date.getTime())) {
                const now = new Date();
                expired = date.getTime() < now.getTime();
            }
        }

        const storage = window.sessionStorage.getItem("announcement-closed");
        if ((!(window as any).isEditor && storage && storage === "true") || expired) {
            if (announcement && announcement.parentElement) {
                announcement.parentElement.removeChild(announcement);
            }
        }

        clsAnnouncement.onclick = (e) => {
            if (clsAnnouncement) {
                const announcement = clsAnnouncement.parentElement;
                if (announcement && announcement.parentElement) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.sessionStorage.setItem("announcement-closed", "true");
                    announcement.parentElement.removeChild(announcement);
                }
            }
        };
    }

    // Cookie banner
    const clsCookie = document.getElementById("dismiss-cookie-banner");
    if (clsCookie) {
        const declineCookie = document.getElementById("decline-cookie-banner");

        const onIsAccepted = () => {
            const dom = document.getElementById('gtag-init');
            if (dom) GtagAccept();
        };

        const accepted = getCookie(GetTrackingCookieName()) === hasAcceptedValue;
        const acceptBtn = document.getElementById("accept-cookie-banner");
        const hasDeclined = window.sessionStorage.getItem("cookie-dismissed") === "true";

        const closeBanner = () => {
            const parent = clsCookie.parentElement;
            if (parent && parent.parentElement) {
                parent.parentElement.remove();
            }
        };

        if (declineCookie) {
            declineCookie.onclick = () =>{
                window.sessionStorage.setItem("cookie-dismissed", "true");
                closeBanner();

            };
        }

        if (accepted || hasDeclined) {
            if (accepted) onIsAccepted();
            closeBanner();
        } else if (acceptBtn) {
            acceptBtn.onclick = () => {
                setCookie(GetTrackingCookieName(), hasAcceptedValue, 365);
                onIsAccepted();
                closeBanner();
            };
        }

        clsCookie.onclick = () => closeBanner();
    } else {
        GtagAccept();
    }

    // Override static links with preview links
    if (window.location.href.endsWith("/preview")) {
        elementsByType['link']?.forEach((link) => {
            if (!link.classList.contains("hierarchy")) return;

            let href = link.getAttribute("href");
            if (href && !href.startsWith("http") && !href.endsWith("/preview")) {
                href = href + "/preview";
                link.setAttribute("href", href);
            }
        });
    }

    // Set CSS variables
    const setCSSVariable = () => {
        try {
            const wbcprimaryBtn = document.getElementById('btnprimarybutton')!;
            const wbcprimaryBtnBg = getComputedStyle(wbcprimaryBtn, '').backgroundColor;
            const loaderAlpha = `rgba(${wbcprimaryBtnBg.slice(4, -1)},0.7)`;
            document.documentElement.style.setProperty("--wbc-primary-button-bg", wbcprimaryBtnBg);
            document.documentElement.style.setProperty("--wbc-loader-alpha", loaderAlpha);
        } catch (error) {
            console.warn(error);
        }
    };
    setCSSVariable();

    // Call onFinish after all operations are done if we aren't waiting on portals to render
    if(portals.length === 0){
        onFinish && onFinish();
    }
}
